import { CarQuote } from './car-quote.model';

export class CarQuoteEmailRequest {
  opportunityId: number;
  email: string;
  carDescription: string;
  statedAmount: number;
  producerCuit: string;
  carQuotes: Array<CarQuote>;
}
